<script lang="ts">
  import ShowCard from "$app/Pages/Plans/Admin/Billing/ShowCard.svelte"
  import Card from "$app/Pages/Signup/Card.svelte"
  import { signupStore } from "$app/signupstore.svelte"
  import { appStore } from "$app/store.svelte"
  import { catchError, toast, xhr } from "$app/utils"
  import { Loader2 } from "lucide-svelte"
  import { slide } from "svelte/transition"

  let { oncomplete }: { oncomplete: () => void } = $props()

  let changeCard = $state(false)
  let card = $state<Card>(null)

  let saving = $state(false)
  async function handleSubmit() {
    saving = true

    const stripe_token = await card.getStripeToken()
    if (stripe_token === "") {
      toast(
        "There was an error with the credit card verification. Please try again.",
        "error"
      )
      saving = false
      return
    }

    const [error, resp] = await catchError(
      xhr.post<StripePaymentMethodType>(
        `/plans/${appStore.plan.id}/admin/billing/update_payment_method`,
        {
          stripe_token: stripe_token
        }
      )
    )

    if (error) {
      toast(
        "There are some errors. Please verify and try again or contact support@leadwithpurpose.com.",
        "error",
        { duration: 30000 }
      )

      saving = false
      return
    }

    saving = false
    toast("You successfully updated your payment method", "success")

    changeCard = false

    oncomplete()
  }
</script>

<div class="flex justify-between py-4 px-8">
  {#if changeCard}
    <div transition:slide>
      <h2 class="text-tertiary text-xl font-semibold">Update Credit Card</h2>
      <div class="flex items-center gap-4">
        <div style="width: 28rem">
          <Card bind:this={card} />
        </div>
        <div class="flex gap-2 pt-4">
          <button
            class="btn primary w-36 flex justify-center items-center"
            onclick={handleSubmit}
            disabled={saving}
          >
            {#if saving}
              <Loader2 class="animate-spin" />
            {:else}
              Update Card
            {/if}
          </button>
          <button
            class="btn outline"
            onclick={() => (changeCard = false)}
            disabled={saving}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  {:else}
    <ShowCard stripe_payment_method={signupStore.stripe_data.payment_method} />
    <div class="p-2 flex justify-end items-center">
      <button
        class="bg-white whitespace-nowrap hover:bg-blue-50 hover:shadow py-3 px-6 text-blue-500 rounded-sm text-sm border border-blue-300"
        onclick={() => (changeCard = true)}>Update Payment Card</button
      >
    </div>
  {/if}
</div>
